export const ERROR_DEFAULT = "出错了！";

export const LIMIT = 10; // 默认 limit

export const OSS_ENDPOINT = "oss-cn-beijing.aliyuncs.com";
export const OSS_BUCKET = "links-comment";
export const DRIVER_LICENSE_PATH = "/comment";

export const OSS_LINK = "//links-comment.oss-cn-beijing.aliyuncs.com";

export const MAX_UPLOAD_NUMBER = 4;

export const URL_REGEXP = /((http(s)?:)?\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;

export const REGEXP = /\[[^[\]]+?\]/g;

export const AVATAR = "";

export const IMAGE_SPLIT = "IMAGE_SPLIT";

export const IMAGE_PROCESS = "?x-oss-process=image/resize,h_350";
export const IMAGE_PROCESS_SMALL = "?x-oss-process=image/resize,h_100";
export const IMAGE_PROCESS_LARGE = "?x-oss-process=image/resize,h_500";

export const COMMENT_TYPE = {
  COMMENT: "comment",
  REPLY: "reply"
};



// WEBPACK FOOTER //
// ./src/constant.js